/**
 * @file Handling translation
 *
 *
 * @author Jaklin Hristova
 * @version 1.0
 *
 * @example
 *
 */

export default {
  methods: {
    getFormattedDateWithMonth (date, isNormalizedDate = false) { // isNormalized date is used if the format of the date is not an integer but is already in a known date format
      const formattedDate = isNormalizedDate ? new Date(date) : new Date(parseInt(date.substr(6)));
      const monthNames = [
        this.insertString('DateTime', 'January'),
        this.insertString('DateTime', 'February'),
        this.insertString('DateTime', 'March'),
        this.insertString('DateTime', 'April'),
        this.insertString('DateTime', 'May'),
        this.insertString('DateTime', 'June'),
        this.insertString('DateTime', 'July'),
        this.insertString('DateTime', 'August'),
        this.insertString('DateTime', 'September'),
        this.insertString('DateTime', 'October'),
        this.insertString('DateTime', 'November'),
        this.insertString('DateTime', 'December')
      ];

      const day = formattedDate.getDate();
      const monthIndex = formattedDate.getMonth();
      const year = formattedDate.getFullYear();

      return monthNames[monthIndex] + ' ' + day + ', ' + year;
    },
    getFormattedDate (date, isNormalizedDate = false, iso = false) {
      const formattedDate = isNormalizedDate ? new Date(date) : new Date(parseInt(date.substr(6)));

      let day = formattedDate.getDate();
      let month = formattedDate.getMonth() + 1; // addition of 1 because getMonth method starts at 0 and ends at 11
      const year = formattedDate.getFullYear();

      if (day < 10) {
        day = '0' + day;
      }

      if (month < 10) {
        month = '0' + month;
      }
      if (iso) {
        return `${year}-${month}-${day}`;
      }
      return `${day}.${month}.${year}`;
    }
  }
};
